/* ============================================================
   画像が届いてから見せる（store #22・2026-08-30）

   直したこと: 商品画像が「一瞬グレー（または白）の板」になってから表示されていた。
   板の正体は、画像が届く前から描かれている
     ・画像の入れ物の地の色（#ffffff。ページの地 #f6f1eb と違う）
     ・売切の暗幕＋SOLDの文字（白い地に暗幕が重なると、のっぺりした濃い灰色になる）

   ここでやること: 画像が届いた印を DOM に付けるだけ。見せ方は nk-custom.css が決める。
     ・届いた画像そのもの        → nk-img-on
     ・その画像の入れ物          → nk-img-ready

   🛑 印は2段階にしてある（このファイルが届かなかったときに、画像や売切表示が消えないように）:
     ・nk-img-hold   … layout/theme.liquid が同期で付ける。入れ物の地をページの地にするだけ。
                       この段だけなら、このファイルが無くても画像も売切の暗幕も普通に出る。
     ・nk-img-reveal … このファイルが**実際に動いたときだけ**下で付ける。
                       画像の出し方と暗幕の待たせ方は、この段が付いているときだけ効く。
   🛑 途中で転んだときは nk-img-reveal を自分で外して、素のテーマの見せ方に戻す（bailOut）。
      印を待つ決まりだけが残ると、商品画像が全部見えなくなるため。
   ⚠️ 遅延読み込み（loading="lazy"）はそのまま。読み込みを早くも遅くもしない。
   ============================================================ */
(function () {
  'use strict';

  // 画像の「入れ物」として印を付ける相手。該当するものすべてに付ける。
  var HOLDERS = [
    '.grid__image-ratio',        // 商品カードの比率箱（コレクション・トップ）
    '.image-wrap',               // 商品ページ本体・サムネイル・その他
    '.grid-product__image-mask'  // 売切の暗幕とSOLDの文字が乗る枠
  ];
  // 🛑 特集ページ（nk-feature-*）の #eee は**元からある帯のデザイン**で、
  //    画像が来る前の仮の色ではない（見出しの背景として最後まで見えている）。
  //    ここを一時的に別の色にすると帯が明滅するので、対象に入れないこと。

  var DONE = 'nk-img-on';      // 画像そのものに付ける
  var FAILED = 'nk-img-failed'; // 届かなかった画像に付ける（#321・見せ方は nk-custom.css が隠す）
  var READY = 'nk-img-ready';  // 入れ物に付ける
  var FLAG = 'nk-img-reveal';  // このファイルが動いている印

  /* 途中で転んだら、印を待つ決まりをまとめて解除して素のテーマの見せ方へ戻す。
     ここを通ると見た目は修理前に戻る（板は見える）が、画像が消える事故は起きない。 */
  function bailOut(err) {
    try {
      document.documentElement.classList.remove(FLAG);
      if (window.console && console.warn) {
        console.warn('nk-image-reveal: 途中で止まったため素の表示に戻しました', err);
      }
    } catch (ignore) {}
  }

  function markHolders(img) {
    for (var i = 0; i < HOLDERS.length; i++) {
      var holder = img.closest(HOLDERS[i]);
      // 入れ物は入れ子になっていることがある（比率箱の外に暗幕の枠がある等）。
      // 見つかったものから上へたどって、同じ種類の入れ物すべてに印を付ける。
      // closest は必ず親から探し直すので、走査位置は毎回上へ動く（無限にならない）。
      while (holder) {
        holder.classList.add(READY);
        holder = holder.parentElement ? holder.parentElement.closest(HOLDERS[i]) : null;
      }
    }
  }

  function reveal(img) {
    img.classList.add(DONE);
    markHolders(img);
  }

  // 届かなかった画像を取り直す回数と間隔（#219）。回数に上限を置き、無い画像（404）を無限に叩かない。
  // #321: 2回（1.5秒・4秒後）では、配信が詰まっている間に使い切って「?」のまま残った（オーナーの iPhone で実際に発生）。
  //       3回に増やし、間隔を 2秒・6秒・15秒へ広げる（詰まりが解けるのを待ってから取り直す）
  var RETRY_MAX = 3;
  var RETRY_DELAYS_MS = [2000, 6000, 15000];

  /* 届かなかった印（#321）。Safari は失敗した画像に「?」の印と説明文字（alt）を描くので、
     印の付いた画像は CSS で隠し、入れ物の地（紙の色）だけを見せる。取り直しに成功したら印を外す */
  function markFailed(img) {
    img.classList.add(FAILED);
  }

  /* 失敗した画像を取り直す（#219）。src を外して付け直すと、ブラウザは同じ URL をもう一度取りに行く。
     配信の途中で切れた・一時的に応答が無かった、を拾うため。戻り値: 予約したら true、上限なら false。 */
  function retry(img) {
    var count = Number(img.dataset.nkImgRetry || 0);
    if (count >= RETRY_MAX) return false;
    img.dataset.nkImgRetry = String(count + 1);
    setTimeout(function () {
      try {
        var src = img.getAttribute('src');
        var srcset = img.getAttribute('srcset');
        if (!src && !srcset) return;
        if (srcset) img.removeAttribute('srcset');
        if (src) img.removeAttribute('src');
        if (srcset) img.setAttribute('srcset', srcset);
        if (src) img.setAttribute('src', src);
      } catch (ignore) {}
    }, RETRY_DELAYS_MS[count] || RETRY_DELAYS_MS[RETRY_DELAYS_MS.length - 1]);
    return true;
  }

  function watch(img) {
    if (!img || img.dataset.nkImgWatched === '1') return;
    img.dataset.nkImgWatched = '1';

    // ⚠️ complete は「決着済み」の意味で、成功したかどうかは問わない。
    //    ここを naturalWidth > 0 で絞ると、**すでに失敗した画像**（広告ブロッカーに
    //    潰された・404）や **src を持たない img** が漏れる。それらは load も error も
    //    二度と鳴らないので、印が永久に付かず、画像が消えたままになる。
    // load / error は once にしない（取り直したあとの結果も同じ聞き手で受ける・#219）
    img.addEventListener('load', function () { img.classList.remove(FAILED); reveal(img); });
    // 届かなかった画像で板が残り続けないよう、失敗のときも印を付ける。そのうえで取り直す（#219）
    img.addEventListener('error', function () { markFailed(img); reveal(img); retry(img); });
    if (img.complete) {
      reveal(img);
      // 決着済みなのに中身が無い（src はあるのに naturalWidth が 0）＝すでに失敗している。取り直す
      // ⚠️ 大きさを持たない SVG も naturalWidth が 0 になるので、隠す前に decode() で本当に壊れているかを確かめる
      if (img.naturalWidth === 0 && (img.getAttribute('src') || img.getAttribute('srcset'))) {
        if (img.decode) {
          img.decode().then(null, function () { markFailed(img); retry(img); });
        } else {
          retry(img);
        }
      }
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      // 1枚でつまずいても、残りの画像を巻き添えにしない
      try { watch(imgs[i]); } catch (err) { bailOut(err); }
    }
  }

  /* 商品ページの写真のスライド（#321）。最初の1枚だけ先に読み、2枚目以降は近づいたら読む指定にした。
     スライドの表示枠は overflow:hidden なので、めくった瞬間に空の枠が見えないよう、
       ・ページが出たあと、すぐ隣（2枚目）だけを先に読む
       ・写真の所を触った・押した・キーで操作した時点で、残りも全部読み始める */
  function warmGallery() {
    var boxes = document.querySelectorAll('[data-product-photos]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        var root = box.closest('.product__photos') || box;
        var slides = box.querySelectorAll('img[loading="lazy"]');
        if (slides[0]) { slides[0].loading = 'eager'; }
        var all = function () {
          var imgs = root.querySelectorAll('img[loading="lazy"]');
          for (var j = 0; j < imgs.length; j++) { imgs[j].loading = 'eager'; }
          root.removeEventListener('pointerdown', all);
          root.removeEventListener('touchstart', all);
          root.removeEventListener('keydown', all);
          root.removeEventListener('mouseenter', all);
        };
        root.addEventListener('pointerdown', all, { passive: true });
        root.addEventListener('touchstart', all, { passive: true });
        root.addEventListener('keydown', all);
        root.addEventListener('mouseenter', all);
      })(boxes[i]);
    }
  }

  function start() {
    try {
      document.documentElement.classList.add(FLAG);
      scan(document);
      if (document.querySelector('[data-product-photos]')) {
        // 最初の1枚の取得を邪魔しないよう、ページの読み込みが終わってから
        if (document.readyState === 'complete') { warmGallery(); }
        else { window.addEventListener('load', warmGallery, { once: true }); }
      }

      // あとから差し込まれる商品（続きを読み込む・クイックビュー・おすすめ商品）にも効かせる
      if (!('MutationObserver' in window)) return;
      new MutationObserver(function (records) {
        try {
          for (var i = 0; i < records.length; i++) {
            var added = records[i].addedNodes;
            for (var j = 0; j < added.length; j++) {
              var node = added[j];
              if (node.nodeType !== 1) continue;              // 要素以外は見ない
              if (node.tagName === 'IMG') watch(node);
              else scan(node);
            }
          }
        } catch (err) { bailOut(err); }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (err) {
      bailOut(err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
